module.exports = __webpack_public_path__ + "img/a12.75cdf6f4.jpeg";